<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :height="height"
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:action>
        <slot name="action"></slot>
      </template>
      <template v-slot:body>
        <slot name="body" :storeAggregate="storeAggregate" :storeDetail="storeDetail">
          <v-sheet
              v-if="!!currentItem"
              class="px-3 py-3"
          >
            <CommonFieldString
                v-if="!!currentItem"
                v-model="currentItem.event_type"
                label="Event type"
                :readonly="true"
            ></CommonFieldString>
<!--            <BaseFieldSelect-->
<!--                v-if="!!storeDetail.common && !!storeDetail.common.data"-->
<!--                v-model="currentItem.event_type"-->
<!--                :items="storeDetail.common.data.event_type"-->
<!--                :return-object="false"-->
<!--                item-text="text"-->
<!--                item-value="value"-->
<!--                class="mt-3"-->
<!--            ></BaseFieldSelect>-->
            <CommonFieldString
                v-if="!!currentItem"
                v-model="currentItem.material_uid"
                :label="$t('material')"
                :readonly="true"
            ></CommonFieldString>
<!--            <CommonPartialSelectFromTable-->
<!--                v-model="currentItem.material_uid"-->
<!--                dto-list-query="MaterialListQueryDTO"-->
<!--                :store-name="storeMaterialName"-->
<!--                :sort-by="['uid']"-->
<!--                :label="$t('material')"-->
<!--                item-text="uid"-->
<!--                class="mt-3"-->
<!--            >-->
<!--            </CommonPartialSelectFromTable>-->
            {{ currentItem.event }}
          </v-sheet>
        </slot>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import {useTableStore} from "@/components/Common/CommonTable"
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";
import BaseFieldText from "@/components/Base/BaseFieldText";
import BaseFieldNumber from "@/components/Base/BaseFieldNumber";
import BaseFieldSelect from "@/components/Base/BaseFieldSelect";
import {v4 as uuidv4} from "uuid";
import {useStepperStore} from "@/components/Common/CommonStepper";
import CommonFieldString from "@/components/Common/CommonFieldString.vue";

export default {
  name: "MaterialEventDetail",

  props: {
    height: {default: null},
    uidItem: {default: null},
    storeName: {type: [String], default: 'MaterialEventDetail'},
    dtoDetailQuery: {default: 'MaterialEventDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'MaterialEventActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'MaterialEventSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'MaterialEventValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'MaterialEventDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'MaterialEventTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonFieldString,
    BaseFieldNumber,
    BaseFieldText,
    BaseFieldString,
    CommonDetail,
    CommonPartialSelectFromTable,
    BaseFieldSelect,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
  },

  methods: {}
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
      storeMaterialName: uuidv4(),
    }
  }
  ,
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreMaterial/locales.json">
</i18n>